module.exports = __webpack_public_path__ + "img/back-arror-left.8d9a4822.svg";